import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Button, Grid, Fade, Paper } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import SecondaryButton from 'components/Global/Buttons/SecondaryButton';
import styled from "styled-components";
import { showModal, hideModal } from "store/state/modals/modal";
import {
  getCompanies,
  ameliorateCompanyError,
  downloadCompanies
} from "store/state/companies";
import ConnectedCompaniesTable from "./CompaniesTable";
import ConnectedCompanyForm from "./CompanyForm";
import { ToastSuccess, ToastError } from "components/Global/Toasts/Toasty";
import TablePaginationHelper from "../../../utils/tablePaginationHelper";

const PrimaryButton = styled(Button)`
  && {
    background: #2196f3;
    color: white;
    font-size: 17px;
    padding: 0px 12px;
    height: auto;
  }
`;

export class Companies extends Component {
  state = {
    shouldShowCreateModal: false,
    shouldShowEditModal: false,
    companyToEdit: null
  };

  tablePaginationHelper = new TablePaginationHelper("338e8052-26ab-4caa-b527-52dba1ac6205", 10);

  componentDidMount() {
    this.props.getCompanies({ page: this.tablePaginationHelper.page, limit: this.tablePaginationHelper.rowsPerPage });
  }

  componentDidUpdate() {
    const { companyError } = this.props;
    if (companyError && companyError.hasError) {
      this.notify();
      this.props.ameliorateCompanyError();
    }
  }
  showCreateModal = () => {
    this.setState({
      shouldShowCreateModal: true,
      companyToEdit: null,
      shouldShowEditModal: false
    });
  };

  setCompanyToEdit = (event, company) => {
    this.setState({
      companyToEdit: company,
      shouldShowEditModal: true,
      shouldShowCreateModal: false
    });
  };

  hideModal = () => {
    this.setState({
      shouldShowCreateModal: false,
      shouldShowEditModal: false
    });
  };

  setModalToRender = () => {
    let modal = null;
    if (this.state.shouldShowCreateModal) {
      modal = (
        <ConnectedCompanyForm
          closeModal={this.hideModal}
          refresh={this.refresh}
        />
      );
    }
    if (this.state.shouldShowEditModal) {
      modal = (
        <ConnectedCompanyForm
          companyId={this.state.companyToEdit}
          closeModal={this.hideModal}
          refresh={this.refresh}
        />
      );
    }
    return modal;
  };
  notify = () =>
    ToastError(
      <Fragment>
        <div style={{ marginTop: 6, marginRight: 8 }}>
          Attempted to create duplicate company. Save failed.
        </div>
      </Fragment>
    );

  download = () => {
    this.props.downloadCompanies({
      page: this.tablePaginationHelper.page,
      limit: this.tablePaginationHelper.rowsPerPage
    });
  };

  render() {
    const { companies, totalCompanyCount } = this.props;

    if (!companies || !companies) {
      return null;
    }
    const companyFormModal = this.setModalToRender();
    return (
      <Fragment>
        {companyFormModal}
        <Fragment>
          <Grid container>
            <Grid item xs={3} className="userActions">
                <SecondaryButton
                  onClick={this.download}
                  aria-label="Add"
                >
                 <ArrowDownward/> Download Table
                </SecondaryButton>
                <SecondaryButton
                  onClick={this.showCreateModal}
                  aria-label="Add"
                >
                  <AddIcon /> Add Company
                </SecondaryButton>
            </Grid>
            <Grid item xs={8} className="userActions">
              <Fragment />
            </Grid>
          </Grid>
        </Fragment>
        <Fade in>
          <Paper elevation={1}>
            <ConnectedCompaniesTable
              className="companies-table"
              companies={companies}
              count={totalCompanyCount}
              onEditCompany={this.setCompanyToEdit}
              retrievePage={this.props.getCompanies}
            />
          </Paper>
        </Fade>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ authentication, companies }) => ({
  authentication,
  companies: companies.companiesPage ? companies.companiesPage.companies : [],
  totalCompanyCount: companies.companiesPage
    ? companies.companiesPage.count
    : 10,
  companyError: companies.companyError
});

export default connect(
  mapStateToProps,
  {
    getCompanies,
    showModal,
    hideModal,
    ameliorateCompanyError,
    downloadCompanies
  }
)(Companies);
